module.exports = {
  INTERNATIONAL: "INT",
  INTERNAL: "ITR",
};
